import React, { useEffect, useState } from 'react';
import axios from "axios";
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers';
import SVG from "react-inlinesvg"
import CustomerContactsModal from './CustomerContactsModal';

export function CustomerContacts(props) {

    const [lCustomer, setLCustomer] = useState({});
    const [contacts, setContacts] = useState([]);
    const [allContacts, setAllContacts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [isLoading, setIsLoading] = useState(true);


    const [showModal, setShowModal] = useState(false);
    const [formTypeDelete, setFormTypeDelete] = useState(false);

    const [editId, setEditId] = useState(0);

    const fetchContactsByCustomer = () => {

        let cid = Object.keys(lCustomer).length > 0 ? lCustomer.id : props.customer.id;
        if (cid === undefined)
            return;

        setSelectedCustomer({ label: props.customer.name, value: props.customer.id })

        axios.get(process.env.REACT_APP_API_URL + '/api/contactsbycustomer/' + cid).then(({ data }) => {
            setAllContacts(data);
            setContacts(data);
            setIsLoading(false);
        }).catch(e => console.log(e));
    };

    const handleSearch = () => {
        var filtered = allContacts;
        if (searchTerm !== '' && searchTerm.length > 2) {
            filtered = allContacts.filter(t => {
                return t.data.name.toLowerCase().includes(searchTerm.toLowerCase()) || t.data.email?.toLowerCase().includes(searchTerm.toLowerCase());
            });

            filtered.sort((a, b) => a.data.name.localeCompare(b.data.name));
        }
        setContacts(filtered);
    }

    const modalClose = () => {
        setShowModal(false);
        setEditId(0);
        setTimeout(() => setFormTypeDelete(false), 300);
    }
    const modalSubmit = () => {
        setShowModal(false);
        fetchContactsByCustomer();
        setEditId(0);
        setTimeout(() => setFormTypeDelete(false), 300);
    }

    useEffect(() => {
        handleSearch();
    }, [searchTerm]);

    const renderContacts = () => {
        return contacts.map((item, index) => {
            return (
                <tr key={item.id}>
                    <td className="py-8">
                        <div className="d-flex">
                            {(item.data.name !== undefined && item.data.name !== "" && item.data.name !== null) && <>
                                <CopyToClipboard className="d-print-none cursor-pointer" text={item.data.name}>
                                    <div className="btn btn-hover-light-primary btn-icon btn-sm mt-n2 ml-n2">
                                        <i><i className="la la-clipboard"></i></i>
                                    </div>
                                </CopyToClipboard>
                                <div className="pl-2">{item.data.name}</div>
                            </>}
                        </div>
                    </td>
                    <td className="py-8">
                        <div className="d-flex">
                            {(item.data.email !== undefined && item.data.email !== "" && item.data.email !== null) && <>
                                <CopyToClipboard className="d-print-none cursor-pointer" text={item.data.email}>
                                    <div className="btn btn-hover-light-primary btn-icon btn-sm mt-n2 ml-n2">
                                        <i><i className="la la-clipboard"></i></i>
                                    </div>
                                </CopyToClipboard>
                                <div className="pl-2">{item.data.email}</div>
                            </>}

                        </div>

                        <div className="d-flex">
                            {(item.data.tel !== undefined && item.data.tel !== "" && item.data.tel) !== null && <>

                                <CopyToClipboard className="d-print-none cursor-pointer" text={item.data.tel}>
                                    <div className="btn btn-hover-light-primary btn-icon btn-sm mt-n2 ml-n2">
                                        <i><i className="la la-clipboard"></i></i>
                                    </div>
                                </CopyToClipboard>
                                <div className="pl-2">{item.data.tel}</div>
                            </>}
                        </div>
                    </td>
                    <td className="py-8">
                        <div className="d-flex">
                            {item.data.info?.split("\r\n").map((sitem, skey) => {
                                return <span key={skey}>{sitem}<br /></span>
                            })}
                        </div>
                    </td>
                    <td className="py-8">
                        <div className="d-flex d-print-none justify-content-end flex-nowrap">
                            <Button variant="btn btn-icon btn-clean btn-hover-light-primary btn-sm mt-n2 mr-2"
                                onClick={() => { setEditId(item.id); setShowModal(true) }}
                            ><i className="la la-pencil icon-md text-primary"></i></Button>
                            <Button variant="btn btn-icon btn-clean btn-hover-light-danger btn-sm mt-n2"
                                onClick={() => { setEditId(item.id); setShowModal(true); setFormTypeDelete(true) }}
                            ><i className="la la-trash icon-md text-danger"></i></Button>
                        </div>
                    </td>
                </tr>
            );
        });
    }


    useEffect(() => {
        if (props.customer !== undefined)
            setLCustomer(props.customer);
    }, [props.customer])
    useEffect(() => {
        if (Object.keys(lCustomer).length > 0)
            fetchContactsByCustomer();
    }, [lCustomer])

    return (<>
        <div className={`${isLoading ? 'd-flex' : 'd-none'} flex-column align-items-center justify-content-center h-full mb-4`}><Spinner animation="border" variant="primary" /></div>
        <div className={`${isLoading ? 'd-none' : 'd-block'} mb-6`}>
            <div className="d-flex d-print-none">

                <div className="input-icon h-40px flex-grow-1">
                    <input
                        type="text"
                        className="form-control form-control-lg form-control-solid h-40px"
                        placeholder="Suchen ..."
                        id="contactsSearch"
                        autoComplete="false"
                        //autoFocus={true}
                        onKeyUp={(e) => setSearchTerm(e.currentTarget.value)}

                    />
                    <span>
                        <span className="svg-icon svg-icon-lg">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                            />
                        </span>
                    </span>
                </div>
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip id="latest-project">Kontakt anlegen</Tooltip>
                    }
                >
                    <div
                        onClick={() => setShowModal(true)}
                        className={`btn btn-icon btn-default btn-hover-primary ml-3 h-40px w-40px flex-shrink-0`}
                    >
                        <span className="svg-icon svg-icon-lg">
                            <SVG
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/Code/Plus.svg"
                                )}
                            />
                        </span>
                    </div>
                </OverlayTrigger>
            </div>

            {allContacts.length > 0 ? <Table responsive variant="lg">
                <thead>
                    <tr>
                        <td style={{ width: '30%' }}>Name</td>
                        <td style={{ width: '30%' }}>Email / Tel</td>
                        <td>Info</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {renderContacts()}
                </tbody>
            </Table>
                : <div className="alert bg-light-info mt-6">Bislang keine Kontakte vorhanden.</div>}
        </div>
        <CustomerContactsModal type={formTypeDelete ? 'delete' : 'edit'} edit={editId} customer={lCustomer} show={showModal} onHide={modalClose} onSubmit={() => modalSubmit()} />
    </>)
}
